import { isRevealed } from '@/helpers/revelio'

// A hidden page is hidden from its URL too, not only from the nav that links to
// it: without the word, typing the address lands you back on the released page
// beside it.
export const leadCaptureGuard = () => (isRevealed() ? true : '/storefront')
